const { getElement } = window.BAO.Utils

function toggleSearchClass () {
  const isMobile = window.matchMedia('(max-width: 767px)').matches
  const searchCloseBtn = getElement('[data-header-search-close]')
  const searchInput = getElement('#mobile-header-search')

  if (!isMobile) {
    return
  }

  searchInput.addEventListener('focus', () => {
    document.body.classList.add('lyt-Site-headerHidden')
  })

  searchCloseBtn.addEventListener('click', () => {
    closeSearchHeader()
  })
}

function closeSearchHeader () {
  const searchResultsContainer = document.querySelector(
    '.kuQuickSearchResultsContainer',
  )

  if (!searchResultsContainer) return

  document.body.classList.remove('lyt-Site-headerHidden')
  document.body.classList.remove('util-SiteOverflowed', 'util-Search-open')
  searchResultsContainer.style.cssText = 'display: none !important'
}

document.addEventListener('drawers:closing', () => {
  const isMobile = window.matchMedia('(max-width: 1200px)').matches

  if (!isMobile) {
    return
  }

  closeSearchHeader()
})

toggleSearchClass()
